import { type FC, type ReactNode } from "react";
import { ChevronRight, CircleHelp, Home } from "lucide-react";

import logoWhite from "@/shared/assets/logo/logo-white.svg";
import { SupportPanel } from "@/pages/lawyer/dashboard/components/SupportPanel";

interface AttorneyAuthLayoutProps {
  children: ReactNode;
  showSettlementBar?: boolean;
}

export const AttorneyAuthLayout: FC<AttorneyAuthLayoutProps> = ({
  children,
  showSettlementBar = false,
}) => {
  return (
    <div className="flex h-dvh flex-col bg-subtle">
      <div className="flex shrink-0 items-center justify-between bg-[#003922] px-6 py-4">
        <div className="flex items-center gap-2">
          <img src={logoWhite} alt="Elayne" className="h-6" />
          <span className="text-base font-medium text-white">for Attorneys</span>
        </div>
        <SupportPanel>
          <button className="flex items-center gap-2 rounded-full bg-white/30 px-4 py-1 text-sm text-white transition-colors hover:bg-white/40">
            <CircleHelp className="h-4 w-4" aria-hidden="true" />
            Help
          </button>
        </SupportPanel>
      </div>

      <div className="relative flex flex-1 flex-col overflow-y-auto">
        <div className="flex flex-1 items-center justify-center px-8 py-8">
          <div className="flex w-full max-w-[500px] flex-col gap-5">{children}</div>
        </div>

        {showSettlementBar && (
          <div className="absolute bottom-8 left-1/2 flex -translate-x-1/2 items-center gap-2 rounded-full border border-primary bg-white px-4 py-2">
            <Home className="h-4 w-4 shrink-0 text-brand" aria-hidden="true" />
            <span className="whitespace-nowrap text-sm text-primary">Settling an estate?</span>
            <a
              href="/"
              className="flex items-center gap-1 whitespace-nowrap text-sm text-primary underline"
            >
              Access our settlement portal
              <ChevronRight className="h-4 w-4" aria-hidden="true" />
            </a>
          </div>
        )}
      </div>
    </div>
  );
};
